// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e5b2beac","732":"5ac6bd49","977":"bad10cb5"}[chunkId] + ".chunk.js";
};